import { memo, useEffect, useState } from 'react';
import { getUserInfo } from '@/sub-luca-plugin/utils/tools';
import { IUserRights } from '@/sub-luca-plugin/types';
import Info from './info';

interface IProps {
    userRights?: IUserRights;
    onClose?: () => void;
}

const Header = ({ userRights, onClose }: IProps) => {
    const [basicInfo, setBasicInfo] = useState({ headImgUrl: '', nickName: '' });

    const initUerInfo = async () => {
        const data = await getUserInfo();
        console.log('userInfo', data);
        setBasicInfo({ ...basicInfo, ...data });
    };

    useEffect(() => {
        initUerInfo();
    }, []);

    return <Info userRights={userRights} basicInfo={basicInfo} onClose={onClose} />;
};

export default memo(Header);
